// src/utils/supabaseUpload.js
import { createClient } from '@supabase/supabase-js';

// Use standard browser envs with fallbacks
const supabase = createClient(
  process.env.REACT_APP_SUPABASE_DATABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

export async function getSignedUpload({ bucket, path, contentType }) {
  const res = await fetch('/.netlify/functions/supaCreateSignedUpload', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bucket, path, contentType })
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to get signed upload URL');
  }
  return res.json(); // { signedUrl, token, path }
}

export async function uploadViaSupabase({ file, bucket, path, contentType }) {
  if (!file) throw new Error('No file provided');
  const { token, path: finalPath } = await getSignedUpload({ bucket, path, contentType: contentType || file.type });
  const { error } = await supabase.storage.from(bucket).uploadToSignedUrl(finalPath, token, file, { contentType: contentType || file.type });
  if (error) throw new Error(error.message || 'Upload failed');
  return { bucket, path: finalPath, size: file.size, contentType: contentType || file.type };
}
